import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  Container,
  useMediaQuery,
  useTheme,
  styled, 
  Typography
} from '@mui/material';
import { Link } from 'react-router-dom';

// Styled components
const StyledLink = styled('a')(({ theme }) => ({
  color: '#0d9488',
  textDecoration: 'none',
  '&:hover': {
    color: 'rgba(13, 148, 136, 0.8)',
  },
  marginRight: theme.spacing(4)
}));

const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
});

const NavLinks = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar position="fixed" color="transparent" elevation={1} sx={{ bgcolor: 'white' }}>
      <Container>
        <StyledToolbar disableGutters>
          <LogoContainer>
            <Link 
              to="/" 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                textDecoration: 'none',
                gap: '8px' // Add some spacing between logo and text
              }}
            >
              <img
                src="\logo.svg"
                alt="Searchable.com Logo"
                style={{ height: '32px' }}
              />
              <Typography
                variant="h6" 
                component="span" 
                sx={{ 
                  fontWeight: 400,
                  color: '#0d9488',
                  '& span': { 
                    fontWeight: 700 
                  }
                }}
              >
                Search<span>eble</span>
              </Typography>
            </Link>
          </LogoContainer>

          {!isMobile && (
            <NavLinks>
              {/* <StyledLink href="#features">Features</StyledLink>
              <StyledLink href="#pricing">Pricing</StyledLink> 
              <StyledLink href="#how">How it Works</StyledLink> */}
              <Button 
                variant="contained" 
                sx={{ 
                  backgroundColor: '#0d9488',
                  '&:hover': {
                    backgroundColor: 'rgba(13, 148, 136, 0.8)',
                  },
                }}
              >
                Get Started
              </Button>
              <StyledLink href=""></StyledLink>
              <Button href="#portal"
                variant="contained" 
                sx={{ 
                  backgroundColor: 'white',
                  color:'rgba(13, 148, 136, 0.8)',
                  '&:hover': {
                    backgroundColor: 'rgba(230, 235, 234, 0.8)',
                  },
                }}
              >
                Customer Portal
              </Button>
            </NavLinks>
          )}
        </StyledToolbar>
      </Container>
    </AppBar>
  );
};

export default Header;